import tippy from 'tippy.js'

const initTooltips = (wrapperElement) => {
  const els = wrapperElement.querySelectorAll('[data-tippy-content]')
  if (els) {
    els.forEach((el) => {
      tippy(el, {
        animation: 'shift-away-subtle',
        theme: 'material',
      })
    })
  }
}

export default initTooltips
